export default __webpack_public_path__ + "static/media/dropdown.df06f1f0.svg";